import React from "react";
import { BOOKING_URL } from "../../utils/tracking";

const BookingWidget = ({ onLoad }) => {
  return (
    <iframe
      src={BOOKING_URL}
      id="timelyWidget"
      title="Radiance Aesthetics online booking"
      onLoad={onLoad}
      style={{
        width: "100%",
        maxWidth: "420px",
        minHeight: "600px",
        border: "none",
        display: "block",
      }}
    ></iframe>
  );
};

export default BookingWidget;
